/**
 *
 * Show modal with unplanned meetings
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, ListGroup } from 'react-bootstrap';
import MeetingItem from './AssignModal/MeetingItem.jsx';
import messages from '../Period/messages.js';

function Unplanned(props) {
  const { meetingList, show, onHide } = props;
  const unplannedMeetings = show && meetingList.filter((m) => !m.details.assigned);
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.unplannedMeetings} />
        </Modal.Title>
      </Modal.Header>
      <ListGroup variant="flush" className="mb-3">
        {show && unplannedMeetings.map((meeting) => (
          <MeetingItem key={meeting.id} meeting={meeting} />
        ))}
      </ListGroup>
    </Modal>
  );
}

Unplanned.propTypes = {
  meetingList: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Unplanned;
